import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import { withRouter } from 'react-router-dom';

import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import { StaticContext, Autocomplete } from '@sm/webassets';
import { defineMessages } from '@sm/intl';

import './search-box.scss';
import publishedApplicationListingsByKeywordQuery from './SearchBox.graphql';
import AppPlaceHolderImg from '../../static/images/app-placeholder.png';

export const COPY = defineMessages({
  SEARCHBOX_PLACEHOLDER: {
    id: 'AppsDirectory.SearchBox.Placeholder',
    defaultMessage: 'Search the App Directory',
    description: '[Type: Label][Vis.: high] - A placeholder text for the search box indicating its intention',
  },
});

function mapItemsToAutocomplete({ publishedApplicationListingsByKeyword: { items } }) {
  return items.map(({ name: text, logo, id, links: { detail: link } }) => ({
    text,
    logo,
    id,
    link,
  }));
}

class SearchBox extends Component {
  state = {
    keyword: '',
  };

  handleTermChanged = keyword => {
    this.setState({ keyword });
  };

  handleItemSelected = ({ link }) => {
    window.location.assign(link);
  };

  handleSubmit = keyword => {
    MetricsTracker.track({
      name: USER_EVENTS.ELEMENT_INTERACTION,
      data: {
        amplitudeEvent: 'app directory searched',
        actionType: 'directory_search.searched',
        actionFlow: 'directory_search',
        searchTerm: keyword,
        location: this.props.location,
      },
    });
    this.props.history.push(`/apps/search?q=${keyword}`);
  };

  render() {
    const { environment } = this.context;
    return (
      <Query
        query={publishedApplicationListingsByKeywordQuery}
        skip={!!this.state.keyword === false}
        variables={{
          subdomain: environment.subdomain,
          tld: environment.tld,
          language: environment.languageId,
          keyword: this.state.keyword,
        }}
      >
        {({ loading, error, data }) => {
          return (
            <div className="sm-search-box">
              <Autocomplete
                placeholder={COPY.SEARCHBOX_PLACEHOLDER.defaultMessage}
                onTextChanged={this.handleTermChanged}
                onItemSelected={this.handleItemSelected}
                onSubmit={this.handleSubmit}
                isLoading={loading}
                hasError={!!error && !!this.state.keyword}
                text={this.state.keyword}
                data={
                  loading || (!!error && !!this.state.keyword) || this.state.keyword === ''
                    ? []
                    : mapItemsToAutocomplete(data)
                }
                renderItem={({ text, logo }) => (
                  <div className="sm-search-box__item">
                    <img alt={text} className="sm-search-box__item-icon" src={logo || AppPlaceHolderImg} />
                    {text}
                  </div>
                )}
              />
            </div>
          );
        }}
      </Query>
    );
  }
}

SearchBox.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.string.isRequired,
};

export default withRouter(SearchBox);
SearchBox.contextType = StaticContext;
